import { ElementType } from 'react';

import { FacetVariant } from '../../types/FacetVariant.ts';
import { SearchDomain } from '../../types/SearchDomain.ts';
import { CurrentRefinementsVirtual } from '../CurrentRefinementsVirtual/CurrentRefinementsVirtual';
import { HitsVirtual } from '../HitsVirtual/HitsVirtual';
import { PaginationVirtual } from '../PaginationVirtual/PaginationVirtual.tsx';
import { RangeVirtual } from '../RangeVirtual/RangeVirtual.tsx';
import { RefinementListVirtual } from '../RefinementListVirtual/RefinementListVirtual.tsx';
import { SortByVirtual } from '../SortByVirtual/SortByVirtual.tsx';
import { useSearchDomainConfig } from '~/routes/Search/components/SearchDomainConfigProvider';

const componentByFacetVariant: Record<FacetVariant, ElementType> = {
  [FacetVariant.REFINEMENT_LIST]: RefinementListVirtual,
  [FacetVariant.RANGE]: RangeVirtual,
};

export interface SearchResultsVirtualProps {
  domain: SearchDomain;
}

export const SearchResultsVirtual = ({ domain }: SearchResultsVirtualProps) => {
  const { searchConfigByDomain } = useSearchDomainConfig();
  const { sortByItems, filters } = searchConfigByDomain(domain);
  return (
    <>
      <HitsVirtual />
      <PaginationVirtual />
      {sortByItems.length > 0 ? <SortByVirtual items={sortByItems} /> : null}
      {filters.map(({ attribute, facetVariant }, index) => {
        const Component = componentByFacetVariant[facetVariant];
        return <Component key={index} attribute={attribute} />;
      })}
      <CurrentRefinementsVirtual />
    </>
  );
};
